import { fetchFloors, fetchFloor, removeFloor } from '../repositories/floor.repository'

const state = {
    floors: [],
    floor: null
}

const actions = {
    fetchFloors ({ commit }) {
        return new Promise(resolve => fetchFloors()
            .then(res => {
                commit('setFloors', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchFloor ({ commit }, id) {
        return new Promise(resolve => fetchFloor(id)
            .then(res => {
                commit('setFloor', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    /* eslint-disable no-unused-vars */
    removeFloor ({ dispatch }, id) {
        return removeFloor(id)
    }
}

const mutations = {
    setFloors (state, floors) {
        state.floors = floors
    },
    setFloor (state, floor) {
        state.floor = floor
    }
}

export default {
    state,
    actions,
    mutations
}